import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { Box, Theme, Typography } from "@mui/material";
import { HelpLinkBar } from "@shared/HelpLinkBar/HelpLinkBar";
import { Modal } from "@shared/Modal/Modal";

const useStyles = makeStyles({ name: "MembersRolesModal" })((theme: Theme) => ({
    role: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        minWidth: 0,
    },
}));

const ROLES = ["owner", "manager", "user"] as const;

export function MembersRolesModal() {
    const { t } = useTranslation(["common", "modals", "pages"]);
    const { classes } = useStyles();
    const [open, setOpen] = useState(false);

    const roles = {
        owner: { name: t("common:role.owner"), description: t("pages:workspacePage.roles.owner") },
        manager: { name: t("common:role.manager"), description: t("pages:workspacePage.roles.manager") },
        user: { name: t("common:role.user"), description: t("pages:workspacePage.roles.user") },
    };

    return (
        <>
            <HelpLinkBar
                label={t("pages:workspacePage.roles.helpLink")}
                tooltip={t("common:tooltip.showRoles")}
                onClick={() => setOpen(true)}
            />
            {open ? (
                <Modal open={open} onClose={() => setOpen(false)} title={t("modals:workspaceRoles.title")}>
                    {ROLES.map((role) => (
                        <Box key={role} className={classes.role}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {roles[role].name}
                            </Typography>
                            <Typography variant="body1">{roles[role].description}</Typography>
                        </Box>
                    ))}
                </Modal>
            ) : null}
        </>
    );
}
